import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setFiles, setPartnerProfileImages } from "../shared/sharedSlice";
import { notify } from "../../../utils/shared";
const API_URL = process.env.REACT_APP_API_URL;
const DEVICES_URL = `${API_URL}/devices`;
const ADD_VIDEO_DETAILS = `${API_URL}/videos`;
const UPDATE_VIDEO_DETAILS = `${API_URL}/videos`;
const APPROVE_VIDEO = `${API_URL}/videos/approve/`;
const COMMON_FILE_UPLOAD = `${API_URL}/fileUpload`;

export const getDevices = createAsyncThunk(
  "getDevices",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { page, limit, search = '', account = '', vinstock = false } = values
      const { data } = await axios.get(`${DEVICES_URL}?page=${page}&limit=${limit}&search=${search}&account=${account}&vinstock=${vinstock}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const commonFileUpload = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setFiles(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const isReportVinError = createAsyncThunk(
  "isReportVinError",
  async (vin: string, { rejectWithValue }) => {
    try {
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.get(`${DEVICES_URL}/is-report-vin-error?vin=${vin}`, {headers: {authorization: user.token}});
      return data;
    } catch (error: any) {
      const { responseMessage } = error?.response?.data;
      return rejectWithValue(error.message);
    }
  }
);

export const partnerProfileImage = createAsyncThunk(
  "commonFileUpload",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios({
        method: "post",
        url: `${COMMON_FILE_UPLOAD}`,
        data: values,
        headers: { "Content-Type": "multipart/form-data" },
      })
      dispatch(setPartnerProfileImages(data))
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const updateQuickTransferDetails = createAsyncThunk(
  "updateQuickTransferDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let selectedPage = values.get("selectedPage")
      const { data } = await axios.put(`${DEVICES_URL}/${values.get("id")}`, values);
      notify(data.responseMessage, 'success');
      dispatch(getDevices({ page: selectedPage || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const changeVideoStatus = createAsyncThunk(
  "changeVideoStatus",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(`${DEVICES_URL}${values?._id}`, { isVerified: !values?.isVerified });
      notify(data.responseMessage, 'success');
      dispatch(getDevices({ page: values.selectedPage || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const addQuickTransferDetails = createAsyncThunk(
  "addQuickTransferDetails",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      let selectedPage = values.get("selectedPage");
      let user: any = localStorage.getItem('kt-auth-react-v');
      user = JSON.parse(user);
      const { data } = await axios.post(`${DEVICES_URL}`, values, {headers: {authorization: user.token}});
      notify(data.responseMessage, 'success');
      dispatch(getDevices({ page: selectedPage || 1, limit: 10 }))
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);


export const deleteQuickTransfer = createAsyncThunk(
  "deleteQuickTransfer",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.delete(`${DEVICES_URL}/${values.id}`);
      notify(data.responseMessage, 'success');
      dispatch(getDevices({ page: values.selectedPage || 1, limit: 10 }));
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage, 'error');
      return rejectWithValue(error.message);
    }
  }
);

export const reportVinError = createAsyncThunk(
  "reportVinError",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.post(`${DEVICES_URL}/report-vin-error`, values);
      notify(data.responseMessage || 'VIN error report submitted successfully. Thank you for helping us improve our service!', 'success');
      return data;
    } catch (error: any) {
      const { responseMessage } = error.response?.data;
      notify(responseMessage || 'Failed to submit report. Please try again later.', 'error');
      return rejectWithValue(error.message);
    }
  }
);
